import {Injectable} from "@angular/core";
import {BtwRekenService, ErrorMessage} from './rekenclient.api';
import {BokkzClient, ValueAddedTaxEntity} from "./api.bokkz.services";
import {BokkzBtwDataService} from "./bokkz-btw-data-service";
import {catchError, map, Observable, of, tap, throwError} from "rxjs";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {ToastService} from "@snelstart/ui-toast";

@Injectable({providedIn: 'root'})
export class BokkzBtwLogic {

  public errorResponse = {} as ErrorMessage[];
  public valueAddedTaxEntity = {} as ValueAddedTaxEntity;
  public aantalValidaties = {} as number;
  public errorString = '';

  constructor(private bokkzClient: BokkzClient,
              private rekenService: BtwRekenService,
              private http: HttpClient,
              private toastService: ToastService,
              public dataService: BokkzBtwDataService,
  ) {
    this.dataService.valueAddedTaxEntity.subscribe((value) => (this.valueAddedTaxEntity = value));
    this.dataService.errorResponse.subscribe((value) => (this.errorResponse = value));
    this.dataService.aantalValidaties.subscribe((value) => (this.aantalValidaties = value));
  }

  public postValueAddedTaxEntity(valueAddedTaxEntity: ValueAddedTaxEntity, sendToAuthorities: boolean): Observable<void> {
    if (!valueAddedTaxEntity || valueAddedTaxEntity.sstRelationId === undefined) {
      return of(void 0);
    }

    return this.bokkzClient.postValueAddedTax(valueAddedTaxEntity.sstRelationId, sendToAuthorities, valueAddedTaxEntity)
      .pipe(
        tap({
          complete: () => {
            this.getCalculation(valueAddedTaxEntity);
          }
        }),
        map(() => void 0),
        catchError(err => {
          this.toastService.showErrorMessage("De gegevens zijn niet opgeslagen.");
          console.log(err);
          return throwError(() => err);
        })
      );
  }

  public getCalculation(valueAddedTaxEntity: ValueAddedTaxEntity) {
    if (valueAddedTaxEntity && valueAddedTaxEntity.overzicht) {
      const overzicht = valueAddedTaxEntity.overzicht;
      if (overzicht) {
        this.rekenService.getValueAddedTaxCalculation(overzicht).subscribe({
          next: (response) => {
            if (response.omzetbelastingNummer != null) {
              this.dataService.updateAantalValidaties(0);
              valueAddedTaxEntity.overzicht = response;
            }
          },
          error: (err) => {
            console.log(err);
          },
          complete: () => {
            this.getValidation();
          }
        });
      }
    }
  }

  public getValidation() {
    if (this.valueAddedTaxEntity && this.valueAddedTaxEntity.overzicht) {
      const overzicht = this.valueAddedTaxEntity?.overzicht;
      if (overzicht) {
        this.rekenService.getValueAddedTaxValidation(overzicht).subscribe({
          next: (response) => {
            if (response.omzetbelastingNummer != null) {
              this.dataService.updateAantalValidaties(0);
            } else {
              if ("HV000028: Unexpected exception during isValid call." === response as unknown as string) {
                this.errorString = response as unknown as string;
                const error: ErrorMessage[] = [{
                  error: "server.error",
                  response: "HV000028: Unexpected exception during isValid call."
                }];
                this.dataService.updateErrorResponse(error);
                this.dataService.updateAantalValidaties(1);
              } else {
                this.dataService.updateErrorResponse(response as unknown as ErrorMessage[]);
                this.dataService.updateAantalValidaties(this.errorResponse.length);
              }
            }
          },
          error: (err) => {
            this.dataService.updateAantalValidaties(0);
            console.log(err);
          }
        });
      }
    }
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error occurred
      console.error('An error occurred:', error.error.message);
    } else {
      // Backend returned an unsuccessful response code
      console.error(`Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return a thrown observable with a user-friendly error message
    return throwError(() => new Error('Something went wrong. Please try again later.'));
  }

}
